<template>
    <div>
      <FormComponent
        @searchForm="getFormData"
        :searchFormItem="formItem"
        :labelWidth="120"
        ref="FormComponent"
        @handleReset="handleReset"
         @onFormChange="onFormChange"
      >
        <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
          <FormItem :label="$t('WHAT_Assessment_PPT')"
            ><!-- WHAT评分 -->
            <Select v-model="formItem.whatScore" clearable>
              <Option v-for="item in Score" :value="item.code" :key="item.code">{{
                lang == "zh" ? item.ch_value : item.en_value
              }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
          <FormItem :label="$t('HOW_Assessment_PPT')"
            ><!-- HOW评分 -->
            <Select v-model="formItem.howScore" clearable>
              <Option v-for="item in Score" :value="item.code" :key="item.code">{{
                lang == "zh" ? item.ch_value : item.en_value
              }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot3">
          <FormItem :label="$t('Overall_Assessment_PPT')"
            ><!-- Overall评分 -->
            <Select v-model="formItem.wholeScore" clearable>
              <Option v-for="item in Score" :value="item.code" :key="item.code">{{
                lang == "zh" ? item.ch_value : item.en_value
              }}</Option>
            </Select>
          </FormItem>
        </Col>
        <!-- 当年度>2025年之后 潜能评分列就隐藏不要显示了 -->
        <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot4" v-if="isShowPotentialScore">
          <FormItem :label="$t('Potential_Rating')"
            ><!-- 潜能评分 -->
            <Select v-model="formItem.potentialScore" clearable>
              <Option
                v-for="item in PotentialScore"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot5"
        v-if="tabName == 'PerformanceEvaluation'"
      >
        <FormItem :label="$t('isSubmit')"
          ><!-- 是否已提交 -->
          <Select v-model="formItem.isSubmit" clearable>
            <Option
              v-for="item in YesOrNoList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
        <Col
          :xs="24"
          :sm="24"
          :md="12"
          :lg="6"
          slot="slot5"
          v-if="tabName != 'PerformanceEvaluation'"
        >
          <FormItem :label="$t('Emp_Ach_mess9')"
            ><!-- 确认状态 -->
            <Select v-model="formItem.peoPleBoardStatus" clearable>
              <Option
                v-for="item in PeoPleBoardStatus"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col
          :xs="24"
          :sm="24"
          :md="12"
          :lg="6"
          slot="slot6"
          v-if="tabName != 'PerformanceEvaluation'"
        >
          <FormItem :label="$t('Management_Level')"
            ><!-- 管理层级 -->
            <Select v-model="formItem.hrmanage" clearable>
              <Option
                v-for="item in ManagementLevel"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col
          :xs="24"
          :sm="24"
          :md="12"
          :lg="6"
          slot="slot7"
          v-if="tabName != 'PerformanceEvaluation'"
        >
          <FormItem :label="$t('Carlsberg_Band')"
            ><!-- 嘉士伯级别 -->
            <Select v-model="formItem.hcmBand" clearable>
              <Option v-for="item in Band" :value="item.code" :key="item.code">{{
                lang == "zh" ? item.ch_value : item.en_value
              }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot8"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      </FormComponent>
      <Table
        border
        :loading="loading"
        :columns="colHidden"
        :data="data"
        style="margin:20px 0"
        @on-select-cancel="TableSelectCancelRow"
        @on-select-all-cancel="cancelAll"
        @on-select-all="selsetAll"
        @on-select="peoOnSelectRow"
        ref="selection"
      >
        <template slot-scope="{ row, index }" slot="whatScore" style="width:100%">
          <Select
            v-model="row.whatScore"
            @on-change="targetItemChange(row, index, 'whatScore')"
            transfer
            :disabled="row.selsetDisabled"
          >
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row, index }" slot="howScore" style="width:100%">
          <Select
            v-model="row.howScore"
            @on-change="targetItemChange(row, index, 'howScore')"
            transfer
            :disabled="row.selsetDisabled"
          >
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </template>
        <template
          slot-scope="{ row, index }"
          slot="wholeScore"
          style="width:100%"
        >
          <Select
            v-model="row.wholeScore"
            @on-change="targetItemChange(row, index, 'wholeScore')"
            transfer
            disabled
          >
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </template>
        <template
          slot-scope="{ row, index }"
          slot="potentialScore"
          style="width:100%"
        >
          <Select
            v-model="row.potentialScore"
            @on-change="targetItemChange(row, index, 'potentialScore')"
            transfer
            :disabled="row.selsetDisabled"
          >
            <Option
              v-for="item in PotentialScore"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </template>
        <template slot-scope="{ row, index }" slot="comment" style="width:100%">
          <Input
            type="textarea"
            v-model="row.comment"
            :autosize="true"
            :disabled="row.selsetDisabled"
            @on-change="targetItemChange(row, index, 'comment')"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            icon="md-reorder"
            size="small"
            :disabled="!row.achApplyId || row.achApplyId == 'NotFindApplyId'"
            @click="checkBtn(row, index)"
          ></Button>
        </template>
        <template slot-scope="{ row, index }" slot="action1">
          <Button
            type="primary"
            icon="md-reorder"
            size="small"
            @click="openApplyPop(row, index)"
          ></Button>
        </template>
      </Table>
      <Table
        :columns="colHiddenA"
        :data="exportTableData"
        ref="TableRef"
        id="Table"
        v-show="false"
      ></Table>
      <div
        style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
      >
        <Page
          :total="total"
          :current="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          transfer
          @on-change="pageChange"
          :page-size-opts="[10, 50, 100, 150]"
          show-sizer
          @on-page-size-change="pageSizeChange"
        />
        <div>
          <Button
            type="primary"
            style="margin-top:15px"
            @click="cancelSubmitMonthed1"
            :disabled="loading"
            v-if="tabName == 'PerformanceEvaluation'"
            ><!-- 取消提交 -->{{ $t("CancelSubmit") }}</Button
          >
          <Button
            type="primary"
            style="margin-top:15px"
            @click="submitTable"
            :disabled="loading"
            v-if="tabName == 'PerformanceEvaluation'"
            ><!-- 提交 -->{{ $t("Submit") }}</Button
          >
        </div>
      </div>
  
      <ApprovalRemark ref="ApprovalRemark" @ok="okSave"></ApprovalRemark>
      <PerformanceEvaluationModal
        ref="PerformanceEvaluationModal"
      ></PerformanceEvaluationModal>
      <Modal
        v-model="checkScoreModel"
        :title="$t('Emp_Ach_mess27')"
        :loading="loading"
        @on-ok="saveTableData"
      >
        <p v-for="(item, index) in checkScoreList" :key="index">
          {{ lang == "zh" ? item.userName : item.userEName }}（{{
            item.empCode
          }}）{{ $t("Emp_Ach_mess13") }}
        </p>
      </Modal>
      <Modal
        v-model="checkAllScoreModel"
        :title="$t('Emp_Ach_mess27')"
        :loading="loading"
        @on-ok="saveAllTableData"
      >
        <p v-for="(item, index) in checkScoreList" :key="index">
          {{ lang == "zh" ? item.userName : item.userEName }}（{{
            item.empCode
          }}）{{ $t("Emp_Ach_mess13") }}
          <!-- 的评分不符合规则，确认是否提交？ -->
        </p>
      </Modal>
      <Modal
        width="800px"
        v-model="checkApplyNotApproval"
        title="有员工目标设定确认未通过,不允许提交初评数据。"
      >
        <!-- <p v-for="(item, index) in checkApplyNotApprovalList" :key="index">
        {{ lang == "zh" ? item.userName : item.userEName }}（{{
          item.empCode
        }}）当前节点确认人 ：{{
          lang == "zh" ? item.approvalCName : item.approvalCName 
        }}（{{
          item.approvalCode
        }}）
      </p> -->
        <Table
          border
          :loading="loading"
          :columns="SubmitCheckColumns"
          :data="checkApplyNotApprovalList"
          ref="Table2"
          style="margin:20px 0"
          :height="checkApplyNotApprovalList.length > 10 ? '500' : ''"
        ></Table>
        <div style="margin:20px 0;display:flex; justify-content: flex-end;">
          <!-- <Page
          :total="total2"
          :current="submitPageInfo.pageNo"
          :page-size="submitPageInfo.pageSize"
          transfer
          @on-change="pageChange2"
        /> -->
          <div style="margin-left: 15px;">
            <Button type="primary" @click="exportData2" :disabled="loading"
              ><!-- 全部确认 -->导出</Button
            >
          </div>
        </div>
      </Modal>
      <Modal
      width="800px"
      v-model="checkBeSubmit"
      title="以下员工已提交过初评分数，请确认数据"
    >
      <!-- <p v-for="(item, index) in checkApplyNotApprovalList" :key="index">
      {{ lang == "zh" ? item.userName : item.userEName }}（{{
        item.empCode
      }}）当前节点确认人 ：{{
        lang == "zh" ? item.approvalCName : item.approvalCName 
      }}（{{
        item.approvalCode
      }}）
    </p> -->
      <Table
        border
        :loading="loading"
        :columns="BeCheckSubmitList"
        :data="checkBeSubmitList"
        ref="Table3"
        style="margin:20px 0"
        :height="checkBeSubmitList.length > 10 ? '500' : ''"
      ></Table>
      <div slot="footer">
        <Button @click="searchTableData"><!-- 保存 -->{{ $t("Confirm") }}</Button>
      </div>
    </Modal>
    <Modal
      width="800px"
      v-model="cancelSubmit"
      title="以下员工已被会议激活,无法取消提交"
    >
      <!-- <p v-for="(item, index) in checkApplyNotApprovalList" :key="index">
      {{ lang == "zh" ? item.userName : item.userEName }}（{{
        item.empCode
      }}）当前节点确认人 ：{{
        lang == "zh" ? item.approvalCName : item.approvalCName 
      }}（{{
        item.approvalCode
      }}）
    </p> -->
      <Table
        border
        :loading="loading"
        :columns="cancelSubmitList"
        :data="cancelSubmitList1"
        ref="Table4"
        style="margin:20px 0"
        :height="checkBeSubmitList.length > 10 ? '500' : ''"
      ></Table>
      <div slot="footer">
        <Button @click="cancelSave"><!-- 保存 -->{{ $t("Confirm") }}</Button>
      </div>
    </Modal>
      <BatchScoring
        ref="BatchScoring"
        :isShowPotentialScore="isShowPotentialScore"
        @batchScoringConfirm="batchScoringConfirm"
      ></BatchScoring>
    </div>
  </template>
  
  <script>
  import FormComponent from "../FormComponent.vue";
  import AchAssessComponentCell from "../AchAssessComponentCell.vue";
  import AchAssessComponentProportion from "../AchAssessComponentProportion.vue";
  import axios from "axios";
  import "../../js/westeros.js";
  import DateUtil from "@/util/DateUtil";
  import ApprovalRemark from "../modalComponents/ApprovalRemark.vue";
  import PerformanceEvaluationModal from "../modalComponents/PerformanceEvaluationModal.vue";
  import BatchScoring from "../modalComponents/BatchScoring.vue";
  export default {
    components: {
      FormComponent,
      AchAssessComponentCell,
      AchAssessComponentProportion,
      ApprovalRemark,
      PerformanceEvaluationModal,
      BatchScoring
    },
    data() {
      return {
        date: new DateUtil(),
        showreturnbtn: false,
        prevent: false,
        formItem: {},
        searchItem: {
           year:""
        },
        selectList: [],
        YesOrNoList:[],
        loading: false,
        total: 0,
        total2: 0,
        pageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 50
        },
        submitPageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 50
        },
        data: [],
        dataTable: [],
        dataChart: [
          { peopleNum: 0 },
          { peopleNum: 0 },
          { peopleNum: 0 },
          { peopleNum: 0 },
          { peopleNum: 0 }
        ],
        spinShow: false,
        radioValue: "1",
        id: "",
        lineData: [0, 0, 0, 0, 0],
        Score: [],
        tabName: "PerformanceEvaluation",
        exportTableData: [],
        PotentialScore: [],
        PeoPleBoardStatus: [],
        isChinaOD: "",
        isBuOd: "",
        returnState: false,
        beEnd: "0",
        tabShow: false,
        tabClickSatae: false,
        allData: [],
        radioIndex: "1",
        ManagementLevel: [],
        Band: [],
        BeQuit: [],
        checkScoreModel: false,
        checkScoreList: [],
        checkAllScoreModel: false,
        checkApplyNotApproval: false,
        checkApplyNotApprovalList: [],
        checkBeSubmit:false,
        checkBeSubmitList:[],
        cancelSubmit:false,
        cancelSubmitList1:[],
        cancelSubmitModal:false,
        overallScoreList:[],
        isShowPotentialScore: true

      };
    },
    computed: {
      //国际化监听
      lang() {
        return this.$store.getters.selectLangeData;
      },
      SubmitCheckColumns() {
        return [
          {
            title: "员工工号",
            key: "empCode",
            align: "center",
            minWidth: 130,
            fixed: "left"
          },
          {
            title: "员工姓名",
            key: this.lang == "zh" ? "userName" : "userEName",
            align: "center",
            minWidth: 120,
            fixed: "left"
          },
          {
            title: "确认人姓名",
            key: this.lang == "zh" ? "approvalCName" : "approvalEName",
            align: "center",
            minWidth: 130,
            fixed: "left"
          },
          {
            title: "确认人工号",
            key: "approvalCode",
            align: "center",
            minWidth: 120,
            fixed: "left"
          }
        ];
      },
      columns() {
        return [
          {
            type: "selection",
            minWidth: 60,
            align: "center",
            fixed: "left"
          },
          {
            title: this.$t("PB_Performance__Sheet") /* 绩效表单 */,
            key: "action",
            slot: "action",
            align: "center",
            minWidth: 100,
            fixed: "left"
          },
          {
            title: this.$t("Emp_Ach_mess9") /* 审批状态 */,
            key: "status",
            align: "center",
            minWidth: 120,
            fixed: "left",
            hidden: this.tabName == "PerformanceEvaluation" ? true : false
          },
          {
            title: this.$t("BU") /* 业务单元 */,
            key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
            align: "center",
            minWidth: 120,
            fixed: "left"
          },
          {
            title: this.$t("Department") /* 部门 */,
            key: this.lang == "zh" ? "department" : "enDepartment",
            align: "center",
            minWidth: 120,
            fixed: "left"
          },
          {
            title: this.$t("Employee_Code") /* 员工号 */,
            key: "empCode",
            align: "center",
            minWidth: 120,
            fixed: "left"
          },
          {
            title: this.$t("Chinese_Name") /* 中文姓名 */,
            key: "userName",
            align: "center",
            minWidth: 120,
            fixed: "left"
          },
          {
            title: this.$t("English_Name") /* 英文名 */,
            key: "userEName",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
            key: "position",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Position_Name_English") /* 职位名称（英文） */,
            key: "positionETitle",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Line_Manager") /* 直线上级 */,
            key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
            align: "center",
            minWidth: 120
            // sortable: true
          },
          {
            title: this.$t("Year") /* 年度 */,
            key: "year",
            align: "center",
            minWidth: 100
          },
          {
            title: this.$t("PB_Resign_Date") /* 离职日期 */,
            key: "quitDate",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("WHAT_Assessment_PPT") /* WHAT评分 */,
            key: "whatScore",
            slot: "whatScore",
            align: "center",
            minWidth: 160
          },
          {
            title: this.$t("HOW_Assessment_PPT") /* HOW评分 */,
            key: "howScore",
            slot: "howScore",
            align: "center",
            minWidth: 160
          },
          {
            title: this.$t("Overall_Assessment_PPT") /* Overall评分 */,
            key: "wholeScore",
            slot: "wholeScore",
            align: "center",
            minWidth: 160
          },
          {
            title: this.$t("Potential_Rating") /* 潜能评分 */,
            key: "potentialScore",
            slot: "potentialScore",
            align: "center",
            minWidth: 160,
            hidden:!this.isShowPotentialScore //当年度>2025年之后 潜能评分列就隐藏不要显示了
          },
          {
            title: this.$t("Remarks") /* 备注 */,
            slot: "comment",
            align: "center",
            minWidth: 160,
            hidden: this.tabName == "PerformanceEvaluation" ? true : false
          },
          {
            title: this.$t("Emp_Ach_mess25") /* 确认记录 */,
            slot: "action1",
            align: "center",
            minWidth: 160,
            hidden: this.tabName == "PerformanceEvaluation" ? true : false
          }
        ];
      },
      columnsA() {
        return [
          {
            title: this.$t("Emp_Ach_mess9") /* 审批状态 */,
            key: "status",
            align: "center",
            minWidth: 120,
            hidden: this.tabName == "PerformanceEvaluation" ? true : false
          },
          {
            title: this.$t("BU") /* 业务单元 */,
            key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Department") /* 部门 */,
            key: this.lang == "zh" ? "department" : "enDepartment",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Employee_Code") /* 员工号 */,
            key: "empCode",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Chinese_Name") /* 中文姓名 */,
            key: "userName",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("English_Name") /* 英文名 */,
            key: "userEName",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
            key: "position",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Position_Name_English") /* 职位名称（英文） */,
            key: "positionETitle",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Line_Manager") /* 直线上级 */,
            key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("Year") /* 年度 */,
            key: "year",
            align: "center",
            minWidth: 100
          },
          {
            title: this.$t("PB_Resign_Date") /* 离职日期 */,
            key: "quitDate",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("WHAT_Assessment_PPT") /* WHAT评分 */,
            key: "whatScore",
            align: "center",
            minWidth: 160
          },
          {
            title: this.$t("HOW_Assessment_PPT") /* HOW评分 */,
            key: "howScore",
            align: "center",
            minWidth: 160
          },
          {
            title: this.$t("Overall_Assessment_PPT") /* Overall评分 */,
            key: "wholeScore",
            align: "center",
            minWidth: 160
          },
          {
            title: this.$t("Potential_Rating") /* 潜能评分 */,
            key: "potentialScore",
            align: "center",
            minWidth: 160,
            hidden:!this.isShowPotentialScore //当年度>2025年之后 潜能评分列就隐藏不要显示了
          },
          {
            title: this.$t("Remarks") /* 备注 */,
            key: "comment",
            align: "center",
            minWidth: 160,
            hidden: this.tabName == "PerformanceEvaluation" ? true : false
          }
        ];
      },
      columnsChart() {
        return [
          {
            title: this.$t("Items") /* 评分项目 */,
            key: this.lang == "zh" ? "scopeType" : "enScopeType",
            align: "center",
            minWidth: 120,
            className: "demo-table-info-column"
          },
          {
            title: this.$t("PB_1-Requires_Improvement") /* 1-需要改善 */,
            key: "achNormal1",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("PB_2-Typically_Meets") /* 2-部分达标 */,
            key: "achNormal2",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("PB_3-Achieved") /* 3-达到要求 */,
            key: "achNormal3",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("PB_4-Exceeds") /* 4-超越要求 */,
            key: "achNormal4",
            align: "center",
            minWidth: 120
          },
          {
            title: this.$t("PB_5-Exceptional") /* 5-优秀出色 */,
            key: "achNormal5",
            align: "center",
            minWidth: 120
          }
        ];
      },
      BeCheckSubmitList(){
        return[
            {
            title: "员工工号",
            key: "empCode",
            align: "center",
            minWidth: 130,
            fixed: "left"
          },
          {
            title: "员工姓名",
            key: this.lang == "zh" ? "userName" : "userEName",
            align: "center",
            minWidth: 120,
            fixed: "left"
          }
        ]
      },
      cancelSubmitList(){
        return[
            {
            title: "员工工号",
            key: "empCode",
            align: "center",
            minWidth: 130,
            fixed: "left"
          },
          {
            title: "员工姓名",
            key: this.lang == "zh" ? "userName" : "userEName",
            align: "center",
            minWidth: 120,
            fixed: "left"
          }
        ]
      },
      colHidden: function() {
        //重点
        return this.columns.filter(function(e) {
          return !e.hidden;
        });
      },
      colHiddenA: function() {
        //重点
        return this.columnsA.filter(function(e) {
          return !e.hidden;
        });
      },
      lang() {
        return this.$store.getters.selectLangeData;
      }
    },
    mounted() {
      this.getListData()
    },
    created() {
      this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
    },
    watch: {
      "$i18n.locale"(newValue) {
        let that = this;
        this.$nextTick(() => {
          that.barLeftChart();
        });
      },
      "searchItem.year"(val) {
        // 当年度>2025年之后 潜能评分列就隐藏不要显示了
        this.isShowPotentialScore = true
        if(val > '2025') {
            this.isShowPotentialScore = false
        }
      }
    },
    methods: {
      onFormChange(e) {
        if(e.key == 'year') {
          this.searchItem.year = this.date.dateVal(e.value, "YYYY") 
        }
      },
      cancelSave(){
        this.cancelSubmit = false;
        this.getData();
      },
      searchTableData(){
        this.checkBeSubmit = false;
        this.getData();
      },
      barLeftChart() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(
          document.getElementById("barLeftChart"),
          "westeros"
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: this.$t("Normal_Distribution_of_Performance"),
            left: "center",
            top: "0"
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            }
          },
          grid: {
            left: "4%",
            right: "10%",
            top: "10%",
            bottom: "10%"
          },
          xAxis: [
            {
              type: "category",
              // data: ["1-需要改善","2-部分达标","3-达到要求","4-超越要求","5-优秀出色"],
              data: [
                this.$t("PB_1-Requires_Improvement"),
                this.$t("PB_2-Typically_Meets"),
                this.$t("PB_3-Achieved"),
                this.$t("PB_4-Exceeds"),
                this.$t("PB_5-Exceptional")
              ],
              axisPointer: {
                type: "shadow"
              }
            }
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              max:
                this.total.toString().length == 1
                  ? 10
                  : this.total >= 10 && this.total < 50
                  ? 50
                  : this.total >= 50 && this.total <= 100
                  ? 100
                  : this.total.toString().length == 3
                  ? 1000
                  : this.total.toString().length == 4
                  ? 10000
                  : 100000,
              interval:
                this.total.toString().length == 1
                  ? 1
                  : this.total >= 10 && this.total < 50
                  ? 5
                  : this.total >= 50 && this.total <= 100
                  ? 10
                  : this.total.toString().length == 3
                  ? 100
                  : this.total.toString().length == 4
                  ? 1000
                  : 10000
              // axisLabel: {
              //   formatter: "{value}"
              // }
            }
            // {
            //   type: "value",
            //   min: 0,
            //   max: 100,
            //   interval: 10,
            //   axisLabel: {
            //     formatter: "{value}%"
            //   }
            // }
          ],
  
          series: [
            {
              name: this.$t("Number"),
              type: "bar",
              barWidth: "50%",
              color: "#4ea397",
              data: [
                {
                  value: this.dataChart[0].peopleNum,
                  itemStyle: {
                    color: "#A5A5A5"
                  }
                },
                {
                  value: this.dataChart[1].peopleNum,
                  itemStyle: {
                    color: "#D9A300"
                  }
                },
                {
                  value: this.dataChart[2].peopleNum,
                  itemStyle: {
                    color: "#8CD29B"
                  }
                },
                {
                  value: this.dataChart[3].peopleNum,
                  itemStyle: {
                    color: "#fc8637"
                  }
                },
                {
                  value: this.dataChart[4].peopleNum,
                  itemStyle: {
                    color: "#4472C4"
                  }
                }
              ]
            },
            {
              name: this.$t("Number"),
              type: "line",
              color: "#006B37",
              data: this.lineData,
              tooltip: {
                show: false
              }
            }
          ]
        });
        window.addEventListener("resize", function() {
          myChart.resize();
        });
      },
  
      getListData() {
        axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
          if (res) {
            this.$refs.FormComponent.positionList = res.positionList;
            this.$refs.FormComponent.departmentList = res.departmentList;
            this.$refs.FormComponent.businessUnitList = res.businessUnitList;
            this.$refs.FormComponent.salesAreaList = res.salesAreaList;
            this.$refs.FormComponent.Level = res.Level;
            this.$refs.FormComponent.YesOrNo = res.YesOrNo;
            this.$refs.FormComponent.BeQuit = res.BeQuit;
            this.$refs.FormComponent.Level = res.Level;
            this.Score = res.Score;
            this.PotentialScore = res.PotentialScore;
            this.$refs.FormComponent.functionList = res.functionList;
            this.$refs.FormComponent.personnelType = res.personnelType;
            // this.$refs.AchAssessComponentCell.Score=res.Score
            // this.$refs.AchAssessComponentCell.PotentialScore=res.PotentialScore
            this.PeoPleBoardStatus = res.PeoPleBoardStatus;
            this.ManagementLevel = res.ManagementLevel;
            this.Band = res.Band;
            this.BeQuit = res.BeQuit;
            this.YesOrNoList = res.YesOrNo;
            this.overallScoreList = res.overallScoreList;
          }
        });
      },
      getData(item) {
        item ? (this.searchItem = JSON.parse(item)) : "";
        let obj = {
          id: this.id,
          ...this.pageInfo,
          ...this.searchItem
        };
        let url = "";
        this.loading = true;
        if (this.tabName == "PerformanceEvaluation") {
          url = "/achReport/selectReportAchAssess";
        } else {
          url = "/AchPeopleBoard/selectAchPeopleBoard";
        }
        this.lineData = [];
        this.dataTable = [];
        axios.post(url, obj).then(res => {
          this.$refs.FormComponent.prevent = false;
          this.loading = false;
          if (res) {
            let that = this;
            this.data = res.achPeopleBoardList;
            this.allData = res.allData;
            if (res.achNormalList.length > 0) {
              this.dataChart = res.achNormalList;
              this.dataChart.forEach(el => {
                this.lineData.push(el.peopleNum);
              });
              this.$nextTick(() => {
                that.barLeftChart();
              });
            } else {
              this.dataChart = [
                { peopleNum: 0 },
                { peopleNum: 0 },
                { peopleNum: 0 },
                { peopleNum: 0 },
                { peopleNum: 0 }
              ];
              this.lineData = [0, 0, 0, 0, 0];
              this.$nextTick(() => {
                that.barLeftChart();
              });
            }
            this.data.forEach((el, index) => {
              el._disabled = false;
              el.selsetDisabled = false;
              // 如果当前登录人是 China OD 或者是 BU OD的话
              if (res.isChinaOD == 1) {
                if (el.disabledFlag != 0 && el.statusCode != 6) {
                  el._disabled = true;
                }
              } else if (res.isBuOd == 1) {
                if (
                  el.disabledFlag != 0 &&
                  (el.statusCode != 20 || el.attribute1 != "BU")
                ) {
                  el._disabled = true;
                }
              } else {
                if (el.disabledFlag == "1") {
                  el._disabled = true;
                  // this.$refs.selection.objData[index]._Disabled = true
                }
              }
              if (this.tabName == "PerformanceEvaluation") {
                if (
                  el.endStatus == "0" ||
                  el.beCanUpdate == "1"
                ) {
                  el.selsetDisabled = true;
                }
              } else {
                if (this.id != "") {
                  if (this.beEnd == "1") {
                    el.selsetDisabled = true;
                    // this.$refs.AchAssessComponentCell.selsetDisabled=true
                  }
                } else {
                  el.disabledFlag == "1"
                    ? (el.selsetDisabled = true)
                    : (el.selsetDisabled = false);
                  // el.disabledFlag=='1'?this.$refs.AchAssessComponentCell.selsetDisabled=true:this.$refs.AchAssessComponentCell.selsetDisabled=false
                }
              }
            });
            this.$nextTick(() => {
              this.selectList.forEach(res => {
                this.data.forEach((el, index) => {
                  el._checked = false;
                  if (el.id === res.id) {
                    this.$refs.selection.objData[index]._isChecked = true;
                  }
                });
              });
            });
            this.total = parseInt(res.pageInfo.total);
            if (res.normalTableList) {
              this.dataTable = res.normalTableList;
            }
  
            // this.$refs.AchAssessComponentProportion.data=res.fifteenTableList
            // this.$refs.AchAssessComponentCell.data=res.fifteenTableList
            this.isChinaOD = res.isChinaOD;
            this.isBuOd = res.isBuOd;
            if (this.tabClickSatae) {
              // this.getfifData(this.radioIndex)
            }
          }
        });
      },
      getFormData(item) {
        this.pageInfo.pageNo = 1;
        this.getData(item);
      },
      tabClick(val) {
        if (val == "name2") {
          this.tabClickSatae = true;
          this.getfifData(this.radioIndex);
        } else {
          this.tabClickSatae = false;
        }
      },
      radioChange(val) {
        this.radioIndex = val;
        this.getfifData(val);
      },
      getfifData(val) {
        let obj = {
          id: this.id,
          ...this.searchItem,
          allData: this.allData,
          type: val
        };
        this.tabShow = true;
        axios.post("/achReport/selectFifteenTableData", obj).then(res => {
          if (res) {
            if (val == "1") {
              this.$refs.AchAssessComponentProportion.data = res;
              this.$refs.AchAssessComponentProportion.allData = this.allData;
            } else {
              this.$refs.AchAssessComponentCell.beEnd = this.beEnd;
              this.$refs.AchAssessComponentCell.data = res;
            }
          }
          this.tabShow = false;
        });
      },
      cancelSubmitMonthed1(){
        if (this.selectList.length > 0) {
          this.$Modal.confirm({
            title: this.$t("pleaseSureCancelEmp"),
            onOk: () => {
              this.cancelSubmitMonthed();
            }
          });
        } else{
          this.$Message.error(this.$t('pleaseSelectNeedCancelEmp'))
        }
      },
      cancelSubmitMonthed(){
        //todo
        this.loading = true;
        axios
          .post("/achReport/cancelSubmitScore", this.selectList)
          .then(res => {
            this.loading = false;
            if (res) {
              if (res.result == 23) {
                console.log("res", res);
                this.cancelSubmitList1 = res.data;
                this.cancelSubmit = true;
              } else {
                console.log("res", res);
                this.selectList = [];
                this.$Message.success(this.$t("取消成功"));
                this.getData(JSON.stringify(this.searchItem));
              }
            }
          });
      },
      getTabData() {},
      async targetItemChange(row, index, key) {
        if (this.selectList.length > 0) {
        this.selectList.forEach((res, i) => {
          if (res.id == row.id) {
            this.$set(this.selectList[i], key, row[`${key}`]);
            this.$set(this.selectList[index], 'wholeScore', this.getOverallScore(row.whatScore , row.howScore));
          }
        });
        key && this.$set(this.data[index], key, row[`${key}`]);
      } else {
        key && this.$set(this.data[index], key, row[`${key}`]);
      }
      console.log(row,"赋值前")
      if(row.whatScore &&  row.howScore){
        this.$set(this.data[index], 'wholeScore', this.getOverallScore(row.whatScore , row.howScore));
        console.log(row,"赋值中")
      }
      console.log(row,"复制后")
      this.$nextTick(() => {
        this.selectList.forEach(res => {
          this.data.forEach((el, index) => {
            el._checked = false;
            if (el.id === res.id && el._disabled != true) {
              this.$refs.selection.objData[index]._isChecked = true;
            }
          });
        });
      });
    },
    getOverallScore(whatScore,howScore){
      let overallScore = "";
      this.overallScoreList.forEach(res=>{
        if(whatScore == res.whatScore && howScore == res.howScore){
          overallScore =  res.overallScore
        }
      })  
      return overallScore
    },
  
      checkScore(item) {
        // let wholeScore = Number(item.wholeScore);
        // let whatScore = Number(item.whatScore);
        // let howScore = Number(item.howScore);
        // // Overall分数不大于What或How的单项分数
        // // 当What和How的分数差异大于1时，Overall的分数需在What和How的分数中间
        // if (wholeScore > whatScore && wholeScore > howScore) {
        //   return false;
        // } else if (
        //   whatScore - howScore > 1 &&
        //   (wholeScore >= whatScore || wholeScore <= howScore)
        // ) {
        //   return false;
        // } else if (
        //   howScore - whatScore > 1 &&
        //   (wholeScore >= howScore || wholeScore <= whatScore)
        // ) {
        //   return false;
        // }
        return true;
      },
      saveTableData() {
        if (this.saveStatus && this.tabName == "PerformanceEvaluation") {
          this.loading = true;
          axios.post("/achReport/saveReportAchAssess", this.data).then(res => {
            this.loading = false;
            if (res) {
              if (res.result == 22){
                this.selectList = [];
                this.checkBeSubmitList = res.data;
                this.checkBeSubmit = true;
              }else{
                this.$Message.success(this.$t("Save_Successful"));
                this.getData(JSON.stringify(this.searchItem));
              }
            }
          });
        } else if (!this.saveStatus && this.tabName == "PerformanceEvaluation") {
          this.loading = true;
          axios
            .post("/achReport/submitReportAchAssess", this.selectList)
            .then(res => {
              this.loading = false;
              if (res) {
                if (res.result == 21) {
                  console.log("res", res);
                  this.checkApplyNotApprovalList = res.data;
                  this.checkApplyNotApproval = true;
                }else if (res.result == 22){
                  this.selectList = [];
                  this.checkBeSubmitList = res.data;
                  this.checkBeSubmit = true;
                } else {
                  console.log("res", res);
                  this.selectList = [];
                  this.$Message.success(this.$t("sbumit_Success"));
                  this.getData(JSON.stringify(this.searchItem));
                }
              }
            });
        } else if (!this.saveStatus && this.tabName != "PerformanceEvaluation") {
          this.selectList.forEach(el => {
            el.decision = "1";
            el.idea = "";
          });
          this.loading = true;
          axios
            .post("/AchPeopleBoard/submitPeopleBoardScore", this.selectList)
            .then(res => {
              if (res) {
                this.selectList = [];
                this.$Message.success(this.$t("sbumit_Success"));
                this.getData(JSON.stringify(this.searchItem));
              } else {
                this.loading = false;
              }
            });
          this.returnState = false;
        } else if (this.saveStatus && this.tabName != "PerformanceEvaluation") {
          this.loading = true;
          axios
            .post("/AchPeopleBoard/savePBApprovalList", this.selectList)
            .then(res => {
              this.loading = false;
              if (res) {
                this.selectList = [];
                this.$Message.success(this.$t("Save_Successful"));
                this.getData(JSON.stringify(this.searchItem));
              }
            });
        }
      },
      saveTable() {
        if (this.tabName == "PerformanceEvaluation") {
          this.saveStatus = true;
          this.checkScoreList = [];
          this.data.forEach(item => {
            if (!this.checkScore(item)) {
              this.checkScoreList.push(item);
            }
          });
          if (this.checkScoreList.length > 0) {
            this.checkScoreModel = true;
          } else {
            this.saveTableData();
          }
        } else {
          this.saveStatus = false;
          if (this.selectList.length > 0) {
            let status = this.selectList.filter(res => res.statusCode == "6");
            let submitStatus = this.selectList.filter(
              res => res.statusCode == "20"
            );
            if (status.length > 0) {
              this.$Message.info(this.$t("Emp_Ach_mess2"));
            } else if (submitStatus.length > 0) {
              this.$Message.info(this.$t("Emp_Ach_mess3"));
            } else {
              this.$Modal.confirm({
                title: this.$t("Emp_Ach_mess4"),
                onOk: () => {
                  // this.$refs.ApprovalRemark.modalShow=true
                  this.checkScoreList = [];
                  this.selectList.forEach(item => {
                    if (!this.checkScore(item)) {
                      this.checkScoreList.push(item);
                    }
                  });
                  if (this.checkScoreList.length > 0) {
                    this.checkScoreModel = true;
                  } else {
                    this.saveTableData();
                  }
                }
              });
            }
          } else {
            this.$Message.error(this.$t("Emp_Ach_mess5"));
          }
        }
      },
      submitTable() {
        this.saveStatus = false;
        if (this.selectList.length > 0) {
          this.$Modal.confirm({
            title: this.$t("longText53"),
            onOk: () => {
              this.checkScoreList = [];
              this.selectList.forEach(item => {
                if (!this.checkScore(item)) {
                  this.checkScoreList.push(item);
                }
              });
              if (this.checkScoreList.length > 0) {
                this.checkScoreModel = true;
              } else {
                this.saveTableData();
              }
            }
          });
        } else {
          this.$Message.error(this.$t("Emp_Ach_mess6"));
        }
      },
      saveNew() {
        this.saveStatus = true;
        if (this.selectList.length > 0) {
          this.saveStatus = true;
          this.checkScoreList = [];
          this.selectList.forEach(item => {
            if (!this.checkScore(item)) {
              this.checkScoreList.push(item);
            }
          });
          if (this.checkScoreList.length > 0) {
            this.checkScoreModel = true;
          } else {
            this.saveTableData();
          }
        } else {
          this.$Message.error(this.$t("Emp_Ach_mess7")); //"请选择需要保存的员工。"
        }
      },
      okSave(val) {
        this.selectList.forEach(el => {
          (el.decision = this.returnState ? "2" : "1"), (el.idea = val);
        });
        this.loading = true;
        axios
          .post("/AchPeopleBoard/submitPeopleBoardScore", this.selectList)
          .then(res => {
            if (res) {
              this.selectList = [];
              this.$Message.success(this.$t("sbumit_Success"));
              this.getData(JSON.stringify(this.searchItem));
            } else {
              this.loading = false;
            }
          });
      },
      itemClick(list) {
        this.selectList = JSON.parse(JSON.stringify(list));
      },
      pushClick() {
        if (this.selectList.length > 0) {
          this.$Modal.confirm({
            title: this.$t("Emp_Ach_mess26"), //确认推送
            onOk: () => {
              axios
                .post("/AchPeopleBoard/chinaODSubmit", this.selectList)
                .then(res => {
                  if (res) {
                    this.$Message.success(this.$t("Emp_Ach_mess8")); //推送成功
                    this.getData(JSON.stringify(this.searchItem));
                    this.$nextTick(() => {
                      this.selectList = [];
                    });
                  }
                });
            }
          });
        } else {
          this.$Message.error(this.$t("Select_Employee"));
        }
      },
      paceTable() {
        axios
          .post("/AchPeopleBoard/synchronizationEvaResult", {
            id: this.id,
            year: this.searchItem.year || this.date.dateVal(new Date(), "YYYY")
          })
          .then(res => {
            if (res) {
              this.getData(JSON.stringify(this.searchItem));
            }
          });
      },
      pageChange(val) {
        this.pageInfo.pageNo = val;
        //TODO
        // this.saveStatus = true;
        // this.saveTableData();
        this.getData(JSON.stringify(this.searchItem));
      },
      // pageChange2(val) {
      //   this.submitPageInfo.pageNo = val;
      //   this.saveStatus = false;
      //   this.saveTableData()
      //   //TODO
      //   // this.getData(JSON.stringify(this.searchItem));
      // },
      pageSizeChange(val) {
        this.pageInfo.pageSize = val;
        this.getData(JSON.stringify(this.searchItem));
      },
      handleSpan({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0 && columnIndex === 1) {
          return [1, 2];
        } else if (rowIndex === 0 && columnIndex === 2) {
          return [0, 0];
        }
        if (rowIndex === 0 && columnIndex === 4) {
          return [1, 5];
        } else if (rowIndex === 0 && columnIndex === 5) {
          return [0, 0];
        }
        if (rowIndex === 2 && columnIndex === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 3 && columnIndex === 0) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        if (rowIndex === 3 && columnIndex === 1) {
          return [1, 2];
        } else if (rowIndex === 3 && columnIndex === 2) {
          return [0, 0];
        }
        if (rowIndex === 3 && columnIndex === 4) {
          return [1, 2];
        } else if (rowIndex === 3 && columnIndex === 5) {
          return [0, 0];
        }
      },
      returnPage() {
        this.$router.back();
      },
      exportData2() {
        this.$nextTick(() => {
          this.$exportExcel(
            "Table2",
            "目标设定确认未通过人员名单" +
              this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
          );
        });
      },
      exportData() {
        let obj = {
          id: this.id,
          pageNo: 1,
          pageSize: 10000,
          ...this.searchItem
        };
        if (this.columnsA[0].key != "status") {
          this.columnsA.splice(0, 0, {
            title: this.$t("Application_Status"), //申请单状态
            key: "status",
            align: "center",
            minWidth: 120
          });
        }
        this.loading = true;
        let link = "";
        if (this.tabName == "PerformanceEvaluation") {
          link = "/achReport/selectReportAchAssess";
        } else {
          link = "/AchPeopleBoard/selectAchPeopleBoard";
        }
        axios.post(link, obj).then(res => {
          if (res) {
            res.achPeopleBoardList.forEach(el => {
              el.whatScore = this.Score.filter(
                item => el.whatScore == item.code
              ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
              el.howScore = this.Score.filter(
                item => el.howScore == item.code
              ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
              el.wholeScore = this.Score.filter(
                item => el.wholeScore == item.code
              ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
              el.potentialScore = this.PotentialScore.filter(
                item => el.potentialScore == item.code
              ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            });
  
            this.$nextTick(() => {
              if (this.tabName == "PerformanceEvaluation") {
                this.$exportExcel(
                  "TableRef",
                  this.$t("Performance_Appraisal") +
                    this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
                  res.achPeopleBoardList
                );
              } else {
                this.$exportExcel(
                  "TableRef",
                  this.$t("Performance_Calibration_Approval") +
                    this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
                  res.achPeopleBoardList
                );
              }
            });
          }
          this.loading = false;
        });
      },
      returnSave() {
        console.log(this.returnState);
        if (this.selectList.length > 0) {
          let returnStatus = this.selectList.filter(res => res.statusCode == "7");
          if (returnStatus.length > 0) {
            return this.$Message.error(this.$t("Emp_Ach_mess10")); //已经退回的申请，请重新确认
          }
          this.$Modal.confirm({
            title: this.$t("Emp_Ach_mess11"), //确认退回
            onOk: () => {
              // this.$refs.ApprovalRemark.modalShow=true
              this.selectList.forEach(el => {
                el.decision = "2";
                el.idea = "";
              });
              this.loading = true;
              axios
                .post("/AchPeopleBoard/submitPeopleBoardScore", this.selectList)
                .then(res => {
                  if (res) {
                    this.selectList = [];
                    this.$Message.success(this.$t("Emp_Ach_mess12"));
                    this.getData(JSON.stringify(this.searchItem));
                  } else {
                    this.loading = false;
                  }
                });
              this.returnState = true;
            }
          });
        } else {
          this.$Message.error(this.$t("Select_Employee"));
        }
      },
      checkBtn(row, index) {
        // this.$router.push({
        //   path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
        //   query: {
        //     id: row.achApplyId,
        //     serialnumber: row.serialnumber,
        //     year: row.year
        //   }
        // });
        const href =
          "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
          row.achApplyId +
          "&serialnumber=" +
          row.serialnumber +
          "&achStage=" +
          row.achStage +
          "&year=" +
          row.year +
          "&userName=" +
          row.userName +
          "&returnFlag='1'";
        window.open(href, "_blank");
      },
      TableSelectCancelRow(selection, row) {
        this.selectList.forEach((el, index) => {
          if (el.id == row.id) {
            this.selectList.splice(index, 1);
          }
        });
      },
      peoOnSelectRow(selection, row) {
        if (!this.selectList.includes(row.id)) {
          this.selectList.push(row);
        }
      },
      selsetAll(selection) {
        this.data.forEach(el => {
          if (!el._disabled) {
            this.selectList.push(el);
          }
        });
        let map = new Map();
        for (let item of this.selectList) {
          map.set(item.id, item);
        }
        this.selectList = [...map.values()];
      },
      cancelAll(selection) {
        this.data.forEach(row => {
          this.selectList.forEach((el, index) => {
            if (el.id == row.id) {
              this.selectList.splice(index, 1);
            }
          });
        });
      },
      handleReset() {
        this.formItem = {};
        this.searchItem.year = this.date.dateVal(new Date(), "YYYY");
        // this.pageInfo.pageNo=1
        // this.getData(JSON.stringify(this.formItem))
      },
      openApplyPop(row, index) {
        this.$refs.PerformanceEvaluationModal.modalShow = true;
        this.$refs.PerformanceEvaluationModal.formItem = row;
        this.$refs.PerformanceEvaluationModal.getData();
      },
      allConfirm() {
        this.$Modal.confirm({
          title: this.$t("Emp_Ach_mess23"), //是否全部确认
          onOk: () => {
            this.loading = true;
            axios
              .post("/AchPeopleBoard/checkConfirmPBApprovalList", {})
              .then(res => {
                this.loading = false;
                if (res) {
                  if (res.flag == "1") {
                    this.checkScoreList = res.achPeopleBoardList;
                    this.checkAllScoreModel = true;
                  } else {
                    this.saveAllTableData();
                  }
                }
              });
          }
        });
      },
      saveAllTableData() {
        this.loading = true;
        axios.post("/AchPeopleBoard/ConfirmPBApprovalList", {}).then(res => {
          this.loading = false;
          if (res) {
            this.$Message.success(this.$t("Approval_Completed"));
            this.getData(JSON.stringify(this.searchItem));
          }
        });
      },
      batchScoreSave() {
        if (this.selectList.length > 0) {
          this.$refs.BatchScoring.modalShow = true;
          this.$refs.BatchScoring.formItem.year = this.searchItem.year;
          this.$refs.BatchScoring.formItem.dataList = this.selectList;
        } else {
          this.$Message.error(this.$t("PleaseSelectNeedScopeEmp")); //"请选择需要评分的员工"
        }
      },
      batchScoringConfirm() {
        this.getData(JSON.stringify(this.searchItem));
        this.batchScoringConfirm2();
      },
      batchScoringConfirm2() {
        this.selectList = [];
      },
      batchScoringConfirm3(res){
        this.selectList = [],
        this.checkBeSubmit =true
        this.checkBeSubmitList= res.data;
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .chartBox {
    width: 100%;
  }
  .chartMain {
    display: flex;
    flex-wrap: wrap;
    .chartTable {
      width: 100%;
    }
    /deep/.ivu-table th {
      background: #006b37;
      color: #fff;
    }
    /deep/.ivu-table td.demo-table-info-column {
      background-color: #006b37;
      color: #fff;
    }
  }
  
  @media screen and (max-width: 900px) {
    .chartBox {
      width: 100%;
    }
    .chartMain {
      flex-wrap: wrap;
      .chartTable {
        width: 100%;
      }
    }
  }
  #barLeftChart {
    zoom: 1.18 !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchReportHRComponents/performance.vue